<template>
<div>
    <RComponent :title="'Affiliate'" :Withdraw="true" :buttons="buttons" />
</div>
</template>

<script>
import RComponent from "@/components/Reusable/Search_table.vue";

export default {

    name: "Affiliate",
    data() {
        return {
            buttons: [{
                    title: "Commision Report",
                    icon: "format_align_left"
                },
                {
                    title: "Withdraw Report",
                    icon: "format_align_right"
                }
            ]
        }
    },
    components: {
        RComponent
    },
    methods: {}
}
</script>
